import './demo.css'

import CinematicShell from '../CinematicShell'
import { DEMO_COPY } from './copy'
import DemoCases from './scenes/DemoCases'
import DemoClose from './scenes/DemoClose'
import DemoIntro from './scenes/DemoIntro'
import DemoLever from './scenes/DemoLever'
import DemoPerspectives from './scenes/DemoPerspectives'
import DemoProblem from './scenes/DemoProblem'
import DemoProcess from './scenes/DemoProcess'
import DemoReport from './scenes/DemoReport'
import DemoRequirements from './scenes/DemoRequirements'
import DemoScience from './scenes/DemoScience'
import DemoSteps from './scenes/DemoSteps'
import DemoTesting from './scenes/DemoTesting'

/**
 * Use Case „Produkt-Demo“: das Demo-Deck 2026 als Scrollstory im Stil von
 * Version 2. Die interne Folie zu Investition und Business Case fehlt bewusst.
 */
const SECTIONS = [
  { id: 'intro', height: 340, tone: 'night', Scene: DemoIntro },
  { id: 'problem', height: 440, tone: 'light', Scene: DemoProblem },
  { id: 'hebel', height: 460, tone: 'night', Scene: DemoLever },
  { id: 'schritte', height: 320, tone: 'light', Scene: DemoSteps },
  { id: 'analyse', height: 400, tone: 'white', Scene: DemoRequirements },
  { id: 'testung', height: 720, tone: 'night', Scene: DemoTesting },
  { id: 'perspektiven', height: 520, tone: 'white', Scene: DemoPerspectives },
  { id: 'matching', height: 560, tone: 'light', Scene: DemoReport },
  { id: 'prozess', height: 480, tone: 'night', Scene: DemoProcess },
  { id: 'wissenschaft', height: 320, tone: 'blue', Scene: DemoScience },
  { id: 'faelle', height: 560, tone: 'white', Scene: DemoCases },
  { id: 'abschluss', height: 420, tone: 'blue', Scene: DemoClose }
]

export default function DemoStory() {
  return <CinematicShell sections={SECTIONS} copy={DEMO_COPY} />
}
